import classnames from 'classnames';

interface EmptyStateProps {
  className?: string;
  message?: string;
}

export default function EmptyState({
  className,
  message = `Please check back soon`,
}: EmptyStateProps) {
  return (
    <p
      className={classnames(
        `font-bold text-center text-gray-600 text-lg`,
        className,
      )}
    >
      {message}
    </p>
  );
}
